import React from 'react';
import { LogIn } from 'lucide-react';

const LoginButton = ({ onClick }) => {
  return (
    <button
      onClick={onClick}
      className="bg-white text-teal-700 px-4 py-2 rounded-lg font-medium hover:bg-gray-100 flex items-center gap-2"
    >
      <LogIn size={16} />
      Login
    </button>
  );
};

export default LoginButton;

